<script setup>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useBugReport } from '@/composables/useBugReport';

const store = useStore();
const route = useRoute();
const { open } = useBugReport();

function handleClick() {
  open(route, store.state);
}
</script>

<template>
  <button
    type="button"
    class="fixed bottom-4 right-4 z-50 flex items-center gap-2 bg-mc-ink text-white rounded-pill px-4 py-2 shadow-mc-md text-xs font-semibold hover:bg-mc-charcoal transition-colors duration-160 focus:outline-none focus-visible:ring-2 focus-visible:ring-mc-blue"
    @click="handleClick"
  >
    <svg
      width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="#cd2127" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
    Report a Problem
  </button>
</template>
